import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import {
  fetchBranchaesbyId,
  getBranchDetails,
} from "../../../services/Branches";
import { getAllServices } from "../../../services/Services";
import MobileDetails from "./MobileDetails";
import MobileScreen from "./MobileScreen";

const MobileView = () => {
  const [businessDetails, setBusinessDetails] = useState(null);
  const [services, setServices] = useState([]);
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useSelector((state) => state.user);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });
  useEffect(() => {
    handleFetchBusinessDetail();
    handleFetchAllServices();
  }, [selectedBranch]);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleFetchBusinessDetail = async () => {
    try {
      setIsLoading(true);
      const responce = await getBranchDetails(selectedBranch[0]);
      setIsLoading(false);
      if (responce.status == 200 || responce.status == 201) {
        let data = responce?.data?.data;
        setBusinessDetails(data);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchBusinessDetail ~ error:", error);
    }
  };

  const handleFetchAllServices = async () => {
    try {
      setIsLoading(true);
      const responce = await getAllServices(selectedBranch[0]);
      setIsLoading(false);
      if (responce?.status == 200 || responce?.status == 201) {
        let data = responce?.data?.data;
        console.log(data, "datadatadatadata");

        setServices(data);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchCategory ~ error:", error);
      handleSnackbarVal(true, "error", error?.data?.message);
    }
  };

  return (
    <AppContainer
      primaryHeading={"Marketplace profile"}
      secondaryHeading={
        "Attract new clients to book online via your business profile on Loba, the world's largest beauty and wellness marketplace."
      }
      childrenProps={{
        sx: {
          padding: { xs: "10px 20px", md: "20px 50px" },
          paddingBottom: "50px !important",
        },
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4.5}>
          <MobileScreen data={businessDetails} services={services} />
        </Grid>
        <Grid item xs={12} sm={7.5}>
          <MobileDetails />
        </Grid>
      </Grid>
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </AppContainer>
  );
};

export default MobileView;
